import "./index.scss"
import { useNavigate } from 'react-router-dom'
import Container from '../../components/Layout/Container'
import { Button } from 'antd'
import { useLottie } from 'lottie-react'
import successAnimation from '../../assets/lottie-confetti.json'

interface IProps {
    title: string;
    subtitle: string;
}

export const Thanks: React.FC<IProps> = ({ title, subtitle }) => {
    const navigate = useNavigate();

    const { View } = useLottie({
        animationData: successAnimation,
        loop: false,
        autoplay: true,
        style: {
            width: '100%',
            height: '400px',
            position: 'absolute',
            top: '35%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
        }
    });

    return (
        <div className="thanks-container">
            <Container>
                <div>
                    {View}
                </div>
                <div className="content">
                    <h1>{title}</h1>
                    <p>{subtitle}</p>
                    <Button type="primary" className="waitlist-button" onClick={() => navigate('/')}>
                        Return Home Page
                    </Button>
                </div>
            </Container>
        </div>
    )
}
